import { useQuery } from "@tanstack/react-query";
import { getFaqDetails } from "../api/getFaqDetails";

export const useFaqDetailsQuery = (faqGroupId: string, faqId: string) => {
  return useQuery({
    queryKey: ["faq", { faqGroupId, faqId }],
    queryFn: async () => {
      return await getFaqDetails(faqGroupId, faqId);
    },
    staleTime: 0,
  });
};
